import React from "react";
import ImageGallery from "../ImageGallery";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function StudentMinistryPage() {
  return (
    <div className="main-content" style={{ maxWidth: 1000, margin: "0 auto", padding: 24 }}>
      <EditableText id="student-ministry.title" defaultContent="大学生事工" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>大学生事工</h1>
      <section style={{ margin: "32px 0" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            padding: "24px 16px",
            textAlign: "center",
            boxShadow: "0 2px 8px #0001",
          }}
        >
          <EditableText
            id="student-ministry.verse"
            defaultContent={"不可叫人小看你年轻，\n总要在言语、行为、爱心、信心 、清洁上，\n都作信徒的榜样。"}
            defaultStyle={{ textAlign: "center", fontWeight: 600, fontSize: "1.2em", color: "#222" }}
          />
          <EditableText
            id="student-ministry.verse-ref"
            defaultContent="- 提摩太前书 4:12"
            defaultStyle={{ textAlign: "center", fontWeight: 400, color: "#555", marginTop: "12px" }}
          />
        </div>
      </section>
      <hr style={{ margin: "32px 0" }} />
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="student-ministry.tbf-title"
          as="h2"
          defaultContent="提摩太圣经团契"
          defaultStyle={{ textAlign: "center", color: "#0693e3", fontWeight: 700 }}
        />
        <EditableText
          id="student-ministry.tbf-p1"
          defaultContent="我们是属于生命河教会的学生团契，提摩太圣经团契，同时也是在伊利诺伊大学正式注册的学生组织。我们的名字由来是圣经中的提摩太前书4:12。"
          defaultStyle={BODY_STYLE}
        />
        <EditableText
          id="student-ministry.tbf-p2"
          defaultContent="我们的使命是建立一个共同学习圣经的社区平台，服事学生，建造学生领袖，将福音传至地极。"
          defaultStyle={BODY_STYLE}
        />
      </section>
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="student-ministry.album-title"
          as="h3"
          defaultContent="相册"
          defaultStyle={{ textAlign: "center", color: "#0693e3", fontWeight: 700 }}
        />
      </section>
      <ImageGallery folder="students_ministry_images" slotId="student-ministry.gallery" width="95%" height="700px" />
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="student-ministry.group-body"
          defaultContent="小组团契提供了一个学习圣经、以赞美与诗歌敬拜神，并且与其他信徒交通的平台。若是您想要参加我们的小组团契，欢迎您填写下面的表格与我们联系。"
          defaultStyle={BODY_STYLE}
        />
      </section>
      <section style={{ margin: "32px 0", textAlign: "center" }}>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfrC_eSX6hT1Zhz9FAA6nKLM0LGl1hO9YXy-iKKc-YlsVJsjw/viewform?usp=sf_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#0693e3",
            color: "#fff",
            padding: "14px 36px",
            borderRadius: 8,
            textDecoration: "none",
            fontWeight: 700,
            fontSize: "1.1em",
          }}
        >
          <EditableText
            id="student-ministry.contact-btn"
            as="span"
            defaultContent="联系我们"
            defaultStyle={{ color: "#fff", fontWeight: 700, fontSize: "1.1em" }}
          />
        </a>
      </section>
      <PageCopyright pageId="student-ministry" />
    </div>
  );
}

export default StudentMinistryPage;
